import { Box, AutocompleteRenderOptionState } from '@mui/material';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { useMemo } from 'react';

interface OptionComponentProps {
    option: string;
    state: AutocompleteRenderOptionState;
}

function OptionComponent({ option, state: { inputValue }, ...props }: OptionComponentProps) {
    const matches = useMemo(() => match(option, inputValue, { insideWords: true }), [option, inputValue]);
    const parts = useMemo(() => parse(option, matches), [option, matches]);

    return (
        <Box component="li" sx={{ '&:hover': { backgroundColor: 'cement.50' } }} {...props}>
            <div>
                {parts.map((part) => (
                    <span
                        key={`${part.text}${Math.random()}`}
                        style={{
                            fontWeight: part.highlight ? 600 : 400,
                        }}>
                        {part.text}
                    </span>
                ))}
            </div>
        </Box>
    );
}

export default OptionComponent;
